<script lang="ts">
import ModuleProfil from '@/generated/modules/ModuleProfil.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: ModuleProfil
})

</script>
